import setStep from "../../../../api/deals/setStep"
import Button from "../../../../components/Button/Button"
import alert from "../../../../helpers/alert"
import extractErrorMessage from "../../../../utils/extractErrorMessage"

const StepControlButtons = ({
    dealId,
    prevStep,
    nextStep,
    update,
    setLoading,
}) => {

    const goBack = async () => {
        try {
            setLoading(true);
            await setStep({
                dealId: dealId,
                step: prevStep,
            });
            update && update();
        } catch (e) {
            alert.error(extractErrorMessage(e?.response?.data) || e?.response?.data || 'Ошибка при переходе на предыдущий шаг');
        } finally {
            setLoading(false);
        }
    }

    const goNext = async () => {
        try {
            setLoading(true);
            await setStep({
                dealId: dealId,
                step: nextStep,
            });
            update && update();
        } catch (e) {
            alert.error(extractErrorMessage(e?.response?.data) || e?.response?.data || 'Ошибка при переходе на следующий шаг');
        } finally {
            setLoading(false);
        }
    }
    return (
        <div style={{
            display: 'flex',
            gap: 10,
            justifyContent: 'space-between',
        }}>
            {
                prevStep ? <div style={{flex: 1, display: 'flex', justifyContent: 'flex-start'}}>
                    <Button text="←" style={{fontSize: 24}} fill onClick={goBack}/>
                </div> : null
            }
            {
                nextStep ? <div style={{flex: 1, display: 'flex', justifyContent: 'flex-end'}}>
                    <Button text="→" style={{fontSize: 24}} fill onClick={goNext}/>
                </div> : null
            }
        </div>
    )
}

export default StepControlButtons;
